import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () =>
    import ('@/containers/DefaultContainer')

// Views
const Dashboard = () =>
    import ('@/views/Dashboard')

// Usuarios - Components
const ListaUsuarios = () =>
    import ('@/views/usuarios/ListaUsuarios')
const CambioPass = () =>
    import ('@/views/usuarios/CambioPass')
const NuevoUsuario = () =>
    import ('@/views/usuarios/NuevoUsuario')
const VerUsuario = () =>
    import ('@/views/usuarios/VerUsuario')
const PermisosUsuario = () =>
    import ('@/views/usuarios/PermisosUsuario')

// Transparencia - Normatividad
const TransNormatividad = () =>
    import ('@/views/transparencia/normatividad/Normatividad')
const TransNormaMenu = () =>
    import ('@/views/transparencia/normatividad/NormaMenu')
const TransNormaSeccion = () =>
    import ('@/views/transparencia/normatividad/NormaSeccion')
const FAQMain = () =>
    import ('@/views/transparencia/faq/FAQMain')
const NominaMain = () =>
    import ('@/views/transparencia/nomina/NominaMain')
const TransparenciaQuincena = () =>
    import ('@/views/transparencia/nomina/Quincena')


//Declaraciones patrimoniales
const DeclaracionesPatrimoniales = () =>
    import ('@/views/declaraciones/DeclaracionesPatrimoniales')
const VerDeclaracion = () =>
    import ('@/views/declaraciones/VerDeclaracion')
const VerDeclaracionV2Inicial = () =>
    import ('@/views/declaraciones/VerDeclaracionV2Inicial')

//Comunicación social
const ComsocialDirectorio = () =>
    import ('@/views/comsocial/directorio/directorioMain')
const DirectorioSeccion = () =>
    import ('@/views/comsocial/directorio/directorioSeccion')
const DirectorioPuesto = () =>
    import ('@/views/comsocial/directorio/directorioPuesto')
const ComsocialNoticias = () =>
    import ('@/views/comsocial/noticias/noticiasMain')
const ComsocialAgregarNoticia = () =>
    import ('@/views/comsocial/noticias/noticiasAgregar')
const ComsocialModificarNoticia = () =>
    import ('@/views/comsocial/noticias/noticiasModificar')
const ComsocialConsultarNoticia = () =>
    import ('@/views/comsocial/noticias/noticiasConsultar')
const AgendaPublicaMain = () =>
    import ('@/views/comsocial/AgendaPublicaMain')

//Tesorería
const Pagoenlinea = () =>
    import ('@/views/tesoreria/pagoenlinea/PagoenlineaMain')
const Repositorio = () =>
    import('@/views/tesoreria/pagoenlinea/Repositorio')
const TrimestreSevac = () =>
    import('@/views/tesoreria/trimestreSevac')
const Sevac = () =>
    import('@/views/tesoreria/sevac')
const Tickets = () =>
    import('@/views/tesoreria/tickets/ticketsMain')


//Trámites
const TramitesInformativo = () =>
    import ('@/views/tramites/informativo/index')

//Denuncias
const atnCiudadanaDenunciasIndex = () =>
    import ('@/views/atnciudadana/denuncias/index')
const atnCiudadanaDenuncia = () =>
    import ('@/views/atnciudadana/denuncias/denuncia')

//Encuestas
const encuestasPresupuestoIndex = () =>
    import ('@/views/encuestas/presupuesto/index')
const encuestasPresupuesto = () =>
    import ('@/views/encuestas/presupuesto/verEncuestaPresupuesto')
const encuestasPresupuestoAgregarVoto = () =>
    import ('@/views/encuestas/presupuesto/agregarVoto')

//Permisos
const ListadoAreas = () =>
    import ('@/views/permisos/ListadoAreas')
const ListadoPermisos = () =>
    import ('@/views/permisos/ListadoPermisos')

// Views - Components
const Page404 = () =>
    import ('@/views/pages/Page404')
const Login = () =>
    import ('@/views/pages/Login')

//Promocion economica
const ListadoPromociones = () =>
    import ('@/views/promocionEconomica/listadoPromocionEconomica')
const VerPromocionEconomica = () =>
    import ('@/views/promocionEconomica/promocionEconomica.view')

//Protección civil y bomberos
const ListadoCuentas = () =>
    import ('@/views/proteccionBomberos/listadoCuentas')
const Cuenta = () =>
    import ('@/views/proteccionBomberos/cuenta.view')

const ListadoExpedientes = () =>
    import ('@/views/proteccionBomberos/listadoExpedientes')
const Expediente = () =>
    import ('@/views/proteccionBomberos/expediente.view')
const ListadoActas = () =>
    import ('@/views/proteccionBomberos/listadoActas')
const Acta = () =>
import ('@/views/proteccionBomberos/acta.view')

Vue.use(Router)

export default new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [{
            path: '/',
            redirect: '/login',
            name: 'Home',
            component: DefaultContainer,
            children: [{
                    path: 'inicio',
                    name: 'Inicio',
                    component: Dashboard
                },
                //================================================================================================
                {
                    path: 'usuarios',
                    name: 'Usuarios',
                    component: ListaUsuarios,
                },
                {
                    path: 'usuarios/nuevo',
                    name: 'Nuevo usuario',
                    component: NuevoUsuario,
                },
                {
                    path: 'usuarios/cambio-pass',
                    name: 'Cambio de contraseña',
                    component: CambioPass,
                },
                {
                    path: 'usuarios/:id',
                    name: 'Información de usuario',
                    component: VerUsuario,
                },
                {
                    path: 'usuarios/:id/permisos',
                    name: 'Permisos de usuario',
                    component: PermisosUsuario,
                },
                //================================================================================================
                {
                    path: 'transparencia/normatividad',
                    name: 'Normatividad',
                    component: TransNormatividad,
                },
                {
                    path: 'transparencia/normatividad/menu/:id',
                    name: 'Normatividad - Menu',
                    component: TransNormaMenu,
                },
                {
                    path: 'transparencia/normatividad/seccion/:id',
                    name: 'Normatividad - Sección',
                    component: TransNormaSeccion,
                },
                {
                    path: 'transparencia/faq',
                    name: 'Preguntas Frecuentes',
                    component: FAQMain,
                },
                {
                    path: 'transparencia/quincenas',
                    name: 'Nómina institucional',
                    component: NominaMain,
                },
                {
                    path: 'transparencia/quincenas/:id',
                    name: 'Nómina - Quincena',
                    component: TransparenciaQuincena,
                },
                //================================================================================================
                {
                    path: 'contraloria/declaraciones',
                    name: 'Declaraciones patrimoniales',
                    component: DeclaracionesPatrimoniales,
                },
                {
                    path: 'contraloria/declaraciones/:id',
                    name: 'Declaración patrimonial',
                    component: VerDeclaracion,
                },
                {
                    path: 'contraloria/declaracionesV2/:id/',
                    name: 'Declaración patrimonialV2',
                    component: VerDeclaracionV2Inicial,
                },
                //================================================================================================

                {
                    path: 'comsocial/directorio',
                    name: 'Directorio institucional',
                    component: ComsocialDirectorio,
                },
                {
                    path: 'comsocial/directorio/puesto/:id',
                    name: 'Directorio puesto',
                    component: DirectorioPuesto,
                },
                {
                    path: 'comsocial/directorio/:id',
                    name: 'Directorio submenú',
                    component: DirectorioSeccion,
                },
                {
                    path: 'comsocial/noticias',
                    name: 'Noticias',
                    component: ComsocialNoticias,
                },
                {
                    path: 'comsocial/noticias/agregar',
                    name: 'Agregar noticia',
                    component: ComsocialAgregarNoticia,
                },
                {
                    path: 'comsocial/noticias/modificar/:id',
                    name: 'Modificar noticia',
                    component: ComsocialModificarNoticia,
                },
                {
                    path: 'comsocial/noticias/:id',
                    name: 'Consultar noticia',
                    component: ComsocialConsultarNoticia,
                },
                {
                    path: 'comsocial/agendaPublica',
                    name: 'Agenda Pública',
                    component: AgendaPublicaMain,
                },


                //================================================================================================

                {
                    path: 'tesoreria/pagoenlinea',
                    name: 'Pago en línea',
                    component: Pagoenlinea,
                },
                {
                    path: 'tesoreria/repositorio',
                    name: 'Repositorio',
                    component: Repositorio,
                },
                {
                    path: 'tesoreria/trimestres',
                    name: 'SEVAC',
                    component: TrimestreSevac,
                },
                {
                    path: 'tesoreria/trimestre/:id/sevac',
                    name: 'SEVAC',
                    component: Sevac,
                },
                {
                    path: 'tesoreria/tickets',
                    name: 'Tickets',
                    component: Tickets,
                },
                
                //================================================================================================
                {
                    path: 'tramites/informativo',
                    name: 'Trámites - Informativo',
                    component: TramitesInformativo,
                },
                //================================================================================================
                {
                    path: 'atnciudadana/denuncias',
                    name: 'Atención Ciudadana - Denuncias',
                    component: atnCiudadanaDenunciasIndex,
                },
                {
                    path: 'atnciudadana/denuncia/:id',
                    name: 'Atención Ciudadana - Denuncia',
                    component: atnCiudadanaDenuncia,
                },
                //================================================================================================
                {
                    path: 'encuestas/presupuesto',
                    name: 'Encuestas - Presupuesto Participativo',
                    component: encuestasPresupuestoIndex,
                },
                {
                    path: 'encuestas/presupuesto/:id',
                    name: 'Presupuesto Participativo',
                    component: encuestasPresupuesto,
                },
                {
                    path: 'encuestas/presupuesto/agregarVoto/:id',
                    name: 'Agregar voto',
                    component: encuestasPresupuestoAgregarVoto,
                },

                //================================================================================================
                {
                    path: 'permisos',
                    name: 'Permisos',
                    component: ListadoAreas,
                },
                {
                    path: 'permisos/:area',
                    name: 'Permisos por área',
                    component: ListadoPermisos,
                },
                //================================================================================================
                {
                    path: 'promocionEconomica/solicitudes',
                    name: 'Solicitudes de trabajo',
                    component: ListadoPromociones,
                },
                {
                    path: 'promocionEconomica/solicitud/:id',
                    name: 'Solicitud de trabajo',
                    component: VerPromocionEconomica,
                },

                //================================================================================================
                {
                    path: 'proteccionBomberos/cuentas',
                    name: 'Cuentas',
                    component: ListadoCuentas,
                },   
                {
                    path: 'proteccionBomberos/cuenta/:id',
                    name: 'Cuenta',
                    component: Cuenta,
                },
                {
                    path: 'proteccionBomberos/cuenta/:id/expedientes',
                    name: 'Expedientes',
                    component: ListadoExpedientes,
                },
                {
                    path: 'proteccionBomberos/cuenta/:idCuenta/expediente/:idExpediente',
                    name: 'Expediente',
                    component: Expediente,
                },
                {
                    path: 'proteccionBomberos/cuenta/:idCuenta/expediente/:id/actas',
                    name: 'Actas',
                    component: ListadoActas,
                },
                
                {
                    path: 'proteccionBomberos/cuenta/:idCuenta/expediente/acta/:idActa',
                    name: 'Acta',
                    component: Acta,
                },

                //================================================================================================
            ]
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            //Cualquier ruta que no exista, se redireccionará al main
            path: '*',
            name: 'Not found',
            component: Page404
        }
    ]
})